module.exports = __webpack_public_path__ + "img/zoom.155fe317.png";